const namespace = {
  summaryTitle: "À propos du quartier",
} as const;

export default namespace;
